import classes from './header.module.css'
import { headerNavItems } from '../../constants/routes'
import { CiSearch } from "react-icons/ci";


export function Header() {

    const path = window.location.pathname

    return (
        <div className={classes.container}>

            <div className={classes.navigationContainer}>
                {
                    headerNavItems?.map((nav, index) => (
                        <div className={`${classes.navItem} ${path === nav.route ? classes.activeNav : ''}`} key={index}>
                            <p className={`${classes.navText} ${path === nav.route ? classes.activeNavText : ''}`}>{nav.name}</p>
                        </div>

                    ))
                }
            </div>

            <CiSearch className={classes.searchIcon} />
        </div >
    )
}